
import { Enums } from '@bode-canada/core';
import Form from '@/ui-kit/components/form';
import FormField from '@/ui-kit/components/form/form-field';
import Button from '@/ui-kit/components/button';
import { ButtonProperty, ButtonPropsEventType } from '@/ui-kit/components/button/enums';
import { FormFieldProperty } from '@/ui-kit/components/form/enums';
import { ControlType } from '@/ui-kit/components/form/controls/enums';
import { TextInputProperty } from '@/ui-kit/components/form/controls/components/text-input/enums';
import { SelectProperty } from '@/ui-kit/components/form/controls/components/select/enums';
import { PhoneInputProperty } from '@/ui-kit/components/form/controls/components/phone-input/enums';
import {
  StyleSizeType,
  StylePositionType,
  StyleColorSchemeType,
} from '@/ui-kit/styles/enums';
import OptionsHelper from '@/utils/OptionsHelper';
import createHowItWorkBuilderFormGroup from './controls/HowItWorksBuilderFormControls';
import HowItWorksBuilderControlName from './enums/HowItWorksBuilderEnums';

export default {
  name: 'HowItWorksBuilderForm',
  components: {
    Form,
    FormField,
    Button,
  },
  data() {
    return {
      howItWorkBuilderFormGroup: createHowItWorkBuilderFormGroup(),
      HowItWorksBuilderControlName,
      StyleSizeType,
      StylePositionType,
      StyleColorSchemeType,
      FormFieldProperty,
      ControlType,
      ButtonProperty,
      ButtonPropsEventType,
      isValid: false,
    };
  },
  computed: {
    formGroup() {
      return this.howItWorkBuilderFormGroup;
    },
    formValue() {
      return this.formGroup.value;
    },
    firstNameProps() {
      return {
        [TextInputProperty.Name]: HowItWorksBuilderControlName.FirstName,
        [TextInputProperty.Label]: 'First Name',
        [TextInputProperty.Placeholder]: 'Enter first name',
      };
    },
    lastNameProps() {
      return {
        [TextInputProperty.Name]: HowItWorksBuilderControlName.LastName,
        [TextInputProperty.Label]: 'Last Name',
        [TextInputProperty.Placeholder]: 'Enter last name',
      };
    },
    emailProps() {
      return {
        [TextInputProperty.Name]: HowItWorksBuilderControlName.Email,
        [TextInputProperty.Label]: 'Email',
        [TextInputProperty.Placeholder]: 'Enter email',
      };
    },
    companyNameProps() {
      return {
        [TextInputProperty.Name]: HowItWorksBuilderControlName.CompanyName,
        [TextInputProperty.Label]: 'Company Name',
        [TextInputProperty.Placeholder]: 'Enter company name',
      };
    },
    locationsProps() {
      return {
        [SelectProperty.Name]: HowItWorksBuilderControlName.Locations,
        [SelectProperty.Label]: 'Location(s)',
        [SelectProperty.Placeholder]: 'Select provinces',
        [SelectProperty.Multiple]: true,
        [SelectProperty.Options]:
          OptionsHelper.mapValuesIntoOptions(Object.values(Enums.ProvinceEnum)),
      };
    },
    phoneProps() {
      return {
        [PhoneInputProperty.Name]: HowItWorksBuilderControlName.Phone,
        [PhoneInputProperty.Placeholder]: '(403) 123-1234',
      };
    },
  },
  destroyed() {
    this.formGroup.reset();
  },
  methods: {
    handleSubmitButtonClick() {
      this.formGroup.validate();

      if (!this.formGroup.isValid) {
        return;
      }

      this.$emit('submit', this.formValue);
    },
    handleCancelButtonClick() {
      this.$emit('cancel');
    },
  },
};
